export default "https://cdn-static.gokick.com/assets/6706629b3df14a4b3713b9aca1ff59a1c44b8347/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";